define(function(require) {
    // only run this script if we're on the events results page
    if (!window.scan || !window.scan.events) {
        return;
    }

    require('bootstrapDatePicker');

    var $ = require('jquery');
    var $form = $('.news-taxonomy-filter-form');
    var $querystring = require('querystring');
    var $dateField = $form.find('input[name=eventsListFilterDate]');
    var $pageField = $form.find('input[name=page]');
    var $audiences = $form.find('button.filter-button.for-audience');
    var $audienceExclusions = $form.find('span[name=audienceExclusions]');
    var areDatesAvailable = window.scan && window.scan.events && window.scan.events.calendarDates;
    var loadedQuerystring = $querystring.parse();
    var viewDate = new Date(loadedQuerystring.eventsListFilterDate || new Date().toString());
    var eventDates = areDatesAvailable ? window.scan.events.calendarDates : [];
    var isCategorySelected = loadedQuerystring['categories'] != null && loadedQuerystring['categories'].toString().trim() != '';
    var isDateSelected = loadedQuerystring['eventsListFilterDate'] != null && loadedQuerystring['eventsListFilterDate'].trim() != '';
    var isLocationSelected = loadedQuerystring['location'] != null && loadedQuerystring['location'].toString().trim() != '';
    var isAnyFilterSelected = isCategorySelected || isDateSelected || isLocationSelected;
    var loadedCategory = isCategorySelected ? loadedQuerystring['categories'] : null;
    var loadedLocation = isLocationSelected ? loadedQuerystring['location'] : null;
    var audiences = [];
    var scanTranslations = require('scanTranslations');
    var cookie = require("cookie");

    var eventBeforeShowDay = function(date) {
        return eventDates.map(Number).indexOf(+date) !== -1 ? 'highlighted' : 'disabled';
    };
    var eventChangeDate = function(event) {
        event.preventDefault();

        var date = (event.date.getMonth() + 1).toString() + '/' + event.date.getDate().toString() + '/' + event.date.getFullYear().toString();

        $pageField.val(1);
        $dateField.val(date);
        $form.submit();

        return false;
    };
    var eventShowAllClick = function (event) {
        if (!isAnyFilterSelected) return false;

        window.location = window.location.href.split('?')[0];

        return false;
    };
    var gtmDataLayerPush = function () {
        var dataLayer = window.dataLayer || [];

        if (isCategorySelected) {
            dataLayer.push({
                'event': 'gaEvent',
                'eventCategory': 'Events',
                'eventAction': 'Category',
                'eventLabel': loadedCategory
            });
        }

        if (isLocationSelected) {
            dataLayer.push({
                'event': 'gaEvent',
                'eventCategory': 'Events',
                'eventAction': 'County',
                'eventLabel': loadedLocation
            });
        }
    };

    scanTranslations.getInstance().then(function (scanTranslationInstance) {
        var options = {
            beforeShowDay: areDatesAvailable ? eventBeforeShowDay : function () { },
            changeDate: eventChangeDate,
            defaultViewDate: { year: viewDate.getFullYear(), month: viewDate.getMonth(), day: viewDate.getDay() },
            todayHighlight: true,
            updateViewDate: false,
            maxViewMode: 2,
            templates: {
                leftArrow: '<i class="fa fa-chevron-left"><span class="sr-only">' + scanTranslationInstance.translate("sr_previous") + '</span></i>',
                rightArrow: '<i class="fa fa-chevron-right"><span class="sr-only">' + scanTranslationInstance.translate("sr_next") + '</span></i>'
            },
            title: "Calendar",
            language: cookie.get('scan_lang') || 'en'
        };

        $.fn.bootstrapDatePicker = $.fn.datepicker.noConflict();
        $.fn.bootstrapDatePicker.dates['en'] = {
            days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            daysMin: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            today: "Today",
            clear: "Clear",
            format: "mm/dd/yyyy",
            titleFormat: "MM yyyy", /* Leverages same syntax as 'format' */
            weekStart: 0
        };
        $.fn.bootstrapDatePicker.dates['es'] = {
            days: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
            daysShort: ["Dom", "Lun", "Mar", "Miér", "Jue", "Vie", "Sáb"],
            daysMin: ["Dom", "Lun", "Mar", "Miér", "Jue", "Vie", "Sáb"],
            months: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
            monthsShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sept", "Oct", "Nov", "Dic"],
            today: "hoy",
            clear: "Clear",
            format: "mm/dd/yyyy",
            titleFormat: "MM yyyy", /* Leverages same syntax as 'format' */
            weekStart: 0
        };

        $('#datepicker').bootstrapDatePicker(options);
        $('#datepicker').bootstrapDatePicker('setDate', viewDate);
        $('#datepicker').bootstrapDatePicker().on('changeDate', eventChangeDate);
        $('#showAllEvents').on('click', eventShowAllClick).addClass(isAnyFilterSelected ? '' : 'disabled').removeClass('invisible');
        $form.attr("action", $form.attr("action") + "#showingResults");

        $dateField.val(loadedQuerystring['eventsListFilterDate']).text(loadedQuerystring['eventsListFilterDate']);
        $pageField.val(loadedQuerystring['page']);
        $audiences.each(function (idx, audience) { audiences.push($(audience).text()); });

        // create form elements for audience exclusions in the querystring;
        // query updates are handled via form submit

        if (loadedQuerystring['excludedAudience'] != null) {
            var qsAudiences = loadedQuerystring['excludedAudience'].toString().split(','); // coalesce single string and array values to array

            $.each(qsAudiences, function (i, qsAudience) {
                var selectedAudienceIndex = audiences.indexOf(decodeURIComponent(qsAudience.replace(/\+/g, ' ')));

                if (audiences.indexOf(qsAudience) > -1) {
                    $audienceExclusions.append(
                        $('<input>')
                            .attr('type', 'hidden')
                            .attr('name', 'excludedAudience')
                            .val(audiences[selectedAudienceIndex])
                    );
                }
            });
        }
    });

    gtmDataLayerPush();
});

